export default __webpack_public_path__ + "static/media/index-circle.c45c8e32.svg";